<template>
  <GalleryThumbnail
    @mouseenter="$emit('mouseenter')"
    @click="$emit('click')"
    :image="image"
    :size="size"
    :top-left-action="topLeftAction"
    :top-right-action="topRightAction"
    :bottom-left-action="bottomLeftAction"
  />
</template>

<script lang="ts">
import { computed, defineComponent, inject, PropType } from "vue"
import GalleryThumbnail, {
  GalleryThumbnailAction,
} from "features/gallery/thumbnail/GalleryThumbnail.vue"
import { GalleryMedium } from "features/gallery/gallery.types"
import {
  ThumbnailRepresentation,
  ThumbnailService,
} from "features/gallery/service/thumbnail.service"

export default defineComponent({
  name: "ServicedGalleryThumbnail",
  components: { GalleryThumbnail },
  props: {
    size: {
      type: Number,
      default: 128,
    },
    medium: {
      type: Object as PropType<GalleryMedium>,
    },
    bottomLeftAction: {
      type: Object as PropType<GalleryThumbnailAction>,
      default: null,
    },
  },
  setup(props) {
    const thumbnailService: ThumbnailService = inject("ThumbnailService")

    const thumbnailRepresentation: ThumbnailRepresentation =
      thumbnailService.registerThumbnail(props.medium)

    const topLeftAction = computed(
      () => thumbnailRepresentation.topLeftAction?.value
    )

    const topRightAction = computed(
      () => thumbnailRepresentation.topRightAction?.value
    )

    const image =
      thumbnailRepresentation.galleryMedium.uploaded_file.thumb.url ??
      thumbnailRepresentation.galleryMedium.uploaded_file.preview.url

    return {
      topLeftAction,
      topRightAction,
      image,
    }
  },
})
</script>
